import Header from "../../components/shared/Header";
import Features from "./Features";
import Hero from "./Hero";
import Quote from "./Quote";
import Roadmap from "./Roadmap";
import Footer from "../../components/shared/Footer";

export default function Home() {
	return (
		<>
			<Header />

			<Hero />

			<Features />

			<Roadmap />

			<Quote />

			<Footer />
		</>
	);
}
